export default __webpack_public_path__ + "images/signet-stargate-white.svg";